import React from 'react';
import PropTypes from 'prop-types';
import Descriptions from '../../../../molecules/Descriptions';
import { moneyFormat } from '../../../../../services/util';

function TabelaRendimentoLiquido({ rendimentoLiquido }) {
  const { salarioLiquido, liquidoComplementar, pat, totalLiquido } =
    rendimentoLiquido;
  return (
    <Descriptions title="Rendimento Líquido">
      <Descriptions.Item label="Líquido Salário">
        <span data-testid="liquidoSalario">{moneyFormat(salarioLiquido)}</span>
      </Descriptions.Item>
      <Descriptions.Item label="Líquido Complementar">
        <span data-testid="liquidoComplementar">
          {moneyFormat(liquidoComplementar)}
        </span>
      </Descriptions.Item>
      <Descriptions.Item label="PAT">
        <span data-testid="pat">{moneyFormat(pat)}</span>
      </Descriptions.Item>
      <Descriptions.Item label="Total Líquido">
        <span data-testid="totalLiquido">{moneyFormat(totalLiquido)}</span>
      </Descriptions.Item>
    </Descriptions>
  );
}

TabelaRendimentoLiquido.propTypes = {
  rendimentoLiquido: PropTypes.shape({
    salarioLiquido: PropTypes.number,
    liquidoComplementar: PropTypes.number,
    pat: PropTypes.number,
    totalLiquido: PropTypes.number,
  }),
};

TabelaRendimentoLiquido.defaultProps = {
  rendimentoLiquido: {
    salarioLiquido: 0,
    liquidoComplementar: 0,
    pat: 0,
    totalLiquido: 0,
  },
};

export default TabelaRendimentoLiquido;
